import axios from 'axios';
import { base_url_api } from '../Utils/baseUrl';

export default axios.create({
  baseURL:base_url_api
});